if (!customElements.get('vm-navigation')) {
  customElements.define('vm-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-menu-open]');
      this.trigger.addEventListener('click', () => {
        this.showPanel('root');
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
      });
      this.querySelector('[data-menu-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        this.trigger.setAttribute('aria-expanded', 'false');
        this.trigger.focus();
      });
      this.querySelectorAll('[data-panel-target]').forEach(button => button.addEventListener('click', () => {
        const target = button.dataset.panelTarget;
        this.showPanel(target);
        this.querySelector(`[data-panel="${target}"] button, [data-panel="${target}"] a`).focus();
      }));
    }
    showPanel(name) {
      this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== name; });
      this.querySelector('.vm-menu__body').scrollTop = 0;
    }
    disconnectedCallback() {
      if (this.dialog && this.dialog.open) document.body.style.overflow = this.previousOverflow || '';
    }
  });
}
